import { render, staticRenderFns } from "./TrustSlider.vue?vue&type=template&id=99a48a66&scoped=true&"
import script from "./TrustSlider.vue?vue&type=script&lang=ts&"
export * from "./TrustSlider.vue?vue&type=script&lang=ts&"
import style0 from "./TrustSlider.vue?vue&type=style&index=0&id=99a48a66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a48a66",
  null
  
)

export default component.exports